const mutationTypes = {
  SET_USERS: 'SET_USERS',
  SET_EDITED_USER: 'SET_EDITED_USER',
  SET_USER: 'SET_USER',
  SET_LOADING: 'SET_LOADING',
  SET_SHOW_DELETED: 'SET_SHOW_DELETED',
}

const actionTypes = {
  FETCH_USERS: 'FETCH_USERS',
  UPDATE_USER: 'UPDATE_USER',
  INVITE_USER: 'INVITE_USER',
  DELETE_USER: 'DELETE_USER',
}

export { mutationTypes, actionTypes }



// WEBPACK FOOTER //
// ./src/store/modules/UsersTypes.js